import { render } from "./RecordingsPage.vue?vue&type=template&id=14f3d01c&ts=true"
import script from "./RecordingsPage.vue?vue&type=script&lang=ts"
export * from "./RecordingsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__